import { computed, Ref } from "@vue/composition-api";
import { asString } from "./common";

export interface CustomAttr {
  custom: Readonly<Ref<boolean>>;
  customError: Readonly<Ref<boolean>>;
}

export const customValidator = (
  inputRef: Ref<string | number>,
  inputValueDirty: Ref<boolean>,
  custom: (value: string) => boolean
): CustomAttr => {
  const customValidate = computed(() => {
    const val = asString(inputRef.value);
    return custom(val);
  });
  return {
    custom: customValidate,
    customError: computed(() => !customValidate.value && inputValueDirty.value)
  };
};
